/**
 * Shared compliance option constants used by both
 * ComplianceQuestionnaireForm and ComplianceDetails components.
 * Single source of truth to prevent label drift.
 */

export const FINANCIAL_IMPACT_OPTIONS = [
  { value: 'BELOW_750M', label: '< $750 Million USD (Non-SOX)' },
  { value: 'ABOVE_750M', label: '≥ $750 Million USD (SOX)' },
  { value: 'UNCERTAIN', label: 'Uncertain (defaults to ≥ $750M for compliance)' },
] as const;

export const SOX_CONTROL_OPTIONS = [
  { value: 'RECONCILIATION', label: 'Reconciliation report reviews' },
  { value: 'JOURNAL_ENTRIES', label: 'Journal entries' },
  { value: 'FINANCIAL_STATEMENT_PREP', label: 'Financial statement preparation' },
  { value: 'REVENUE_RECOGNITION', label: 'Revenue recognition' },
  { value: 'INVENTORY_VALUATION', label: 'Inventory valuation' },
  { value: 'FIXED_ASSET_ACCOUNTING', label: 'Fixed asset accounting' },
  { value: 'TAX_CALCULATIONS', label: 'Tax calculations' },
  { value: 'REGULATORY_FILINGS', label: 'Regulatory filings (SEC, 10-K, 10-Q)' },
  { value: 'NONE', label: 'None of the above' },
] as const;

// Derived lookup maps for display components
export const IMPACT_LABELS: Record<string, string> = Object.fromEntries(
  FINANCIAL_IMPACT_OPTIONS.map(o => [o.value, o.label]),
);

export const CONTROL_LABELS: Record<string, string> = Object.fromEntries(
  SOX_CONTROL_OPTIONS.map(o => [o.value, o.label]),
);
